export default __webpack_public_path__ + "static/media/total-transections-icon.b181e7bc.svg";